export const CoreInitiativesSonarObjectsName = 'CoreInitiativesSonarObjects';
